import { render, staticRenderFns } from "./StaticApi.vue?vue&type=template&id=46a745dc&scoped=true"
import script from "./StaticApi.vue?vue&type=script&lang=js"
export * from "./StaticApi.vue?vue&type=script&lang=js"
import style0 from "./StaticApi.vue?vue&type=style&index=0&id=46a745dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a745dc",
  null
  
)

export default component.exports